import { render, staticRenderFns } from "./AddUpdateKnowledgeUnit.vue?vue&type=template&id=ce0e1988&"
import script from "./AddUpdateKnowledgeUnit.vue?vue&type=script&lang=js&"
export * from "./AddUpdateKnowledgeUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports